import React from 'react'

function Loading() {
  return (
    <p>Loading...</p>
  )
}

export {
  Loading
}
